class TextFormElementController {
  constructor() {

  }
}

export default TextFormElementController;
